import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Document/MassiveDownload/CanCreateMassiveDownload', method: 'GET', token: token })
}
